import React from 'react';
import { useAppDispatch } from 'ducks/hooks';
import { getConfigSorting, sortingApplied } from 'ducks/products';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import ListView, { ListViewItem } from '@ingka/list-view';
import { SortingConfig } from 'rangeConfig/@types';
import { reportSortingApplied } from 'analytics/reporters';
import { useWidget } from 'contexts/widget';

type Props = Omit<React.ComponentProps<typeof ListView>, 'id'>;

const SortingList = React.forwardRef<HTMLUListElement, Props>(({ onClick }, ref) => {
  const { config, groupId, subMenuId, configId } = useWidget();
  const sorting = useSelector(getConfigSorting(configId));
  const dispatch = useAppDispatch();
  const { formatMessage } = useIntl();

  const sortingAlternatives = config?.sorting ?? [];

  if (!sortingAlternatives.length) return null;

  const onChoice = ({ id, compare }: SortingConfig) => {
    reportSortingApplied({ groupId, subMenuId, sortingId: id });

    dispatch(
      sortingApplied({
        id,
        compare,
        identifier: configId
      })
    );
  };

  return (
    <ListView
      ref={ref}
      id={`sorting-list-${configId}`}
      size="small"
      showDivider={false}
      onClick={onClick}
    >
      {sortingAlternatives.map(alt => (
        <ListViewItem
          controlProps={{ value: alt.id, checked: sorting?.id === alt.id }}
          onChange={() => onChoice(alt)}
          key={alt.id}
          id={alt.id}
          control="radiobutton"
          title={formatMessage({ id: alt.title })}
          inset
        />
      ))}
    </ListView>
  );
});

export default SortingList;
